/**
 * Created by yihong on 4/10/18.
 */

export function is_mobile(mobile) {
  return /^\d{11}$/.test(mobile)
}

// import {validator} from 'id-card-validator'
import ClsIDCard from './idcard'
export function is_idcard(idcard) {
  return new ClsIDCard(idcard).IsValid();
}



// WEBPACK FOOTER //
// ./src/tools/validate.js